import { ChipProps } from '@mui/material';
import { ValueOf } from 'type-fest';

// Mirrors galaxy-server's tenant lifecycle state machine (RDM-1409):
// Creating -> Awaiting Infrastructure -> Ready -> Archived -> Decommissioned,
// with Creation Failed (create-time hard error) and Partially Removed
// (decommission retry) as recovery states.
export enum TenantStatusTypes {
  Creating = 'Creating',
  AwaitingInfrastructure = 'Awaiting Infrastructure',
  CreationFailed = 'Creation Failed',
  Ready = 'Ready',
  // Testing-only counterpart of Ready (verify ran against BORROWED mock infra).
  // Deliberately NOT treated as Ready anywhere Ready gates behavior — galaxy's
  // backup cron and realm-creation gate skip it, and so do our Ready-keyed checks.
  MockReady = 'Mock Ready',
  Archived = 'Archived',
  PartiallyRemoved = 'Partially Removed',
  Decommissioned = 'Decommissioned',
}

export enum TenantTypes {
  Shared = 'Shared', // Matching glx server values
  Enterprise = 'Enterprise',
  Single = 'Single',
}

export const tenantTypeConfigs: Record<
  TenantTypes,
  { value: TenantTypes; label: string; color: ChipProps['color'] }
> = {
  [TenantTypes.Shared]: {
    value: TenantTypes.Shared,
    label: 'Shared',
    color: 'info',
  },
  [TenantTypes.Enterprise]: {
    value: TenantTypes.Enterprise,
    label: 'Enterprise',
    color: 'success',
  },
  [TenantTypes.Single]: {
    value: TenantTypes.Single,
    label: 'Single',
    color: 'warning',
  },
} as const;

// The statuses a tenant traverses during onboarding, before it is fully Ready.
// Management forms (secret mappings, service registration) must accept these —
// that setup work is exactly what moves a tenant toward Ready.
export const onboardingTenantStatuses = new Set([
  TenantStatusTypes.Creating,
  TenantStatusTypes.AwaitingInfrastructure,
  TenantStatusTypes.CreationFailed,
]);

export const TENANT_TABLE_VIEW = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
};

export const DEFAULT_TENANT_TABLE_VIEW = TENANT_TABLE_VIEW.ACTIVE;

export const TENANT_TABLE_VIEW_ARRAY = [
  {
    label: 'Active',
    value: TENANT_TABLE_VIEW.ACTIVE,
  },
  {
    label: 'Archived',
    value: TENANT_TABLE_VIEW.ARCHIVED,
  },
];

export type TenantViewType = ValueOf<typeof TENANT_TABLE_VIEW>;

export enum TenantIsoStateIds {
  ActiveTenantTable = 'ActiveTenantTable',
  ArchivedTenantTable = 'ArchivedTenantTable',
}
